import { useBootstrap } from '../context/BootstrapContext'

export function useHeroes() {
  const { data, loading } = useBootstrap()
  return { heroes: data.heroes, loading }
}
